import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

function useUserDetail() {
  const { data, status } = useQuery(queries.user.detail());
  const { pop } = useFlow();
  const toast = useToast();
  useEffect(() => {
    if (status === 'error') {
      toast.error('사용자 정보를 불러오는데 실패했습니다.');
      pop();
    }
  }, [status, pop, toast]);
  return data;
}

export default useUserDetail;
